import { render, staticRenderFns } from "./CambiarImagenModal.vue?vue&type=template&id=34a3942a"
import script from "./CambiarImagenModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CambiarImagenModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports